import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";
import { Helmet } from "react-helmet";

import Disclaimers from "components/home/Disclaimers";
import Footer from "components/home/Footer";
import Guides from "components/home/Guides";
import { useCurrentTenant } from "contexts/currentTenant";
import { useServerVariables } from "contexts/serverVariables";
import { useGuides } from "queries/guides";

import styles from "./Home.scss";

const Home = () => {
  const tenant = useCurrentTenant();

  const {
    name: tenantName,
    state_abbreviation: stateAbbreviation,
    home_page_title,
    site_title,
    home_page_message,
    bounds,
    address,
    phone,
    zipcode,
    website_url: websiteURL,
    municipality_type: municipalityType,
    disclaimer,
  } = tenant;
  const { fixedGuideId } = useServerVariables();
  const { data: propsFromGuides = {} } = useGuides({
    select: (guides) => {
      if (fixedGuideId) {
        const guide = R.find(R.propEq(fixedGuideId, "id"), guides);
        return {
          guides: [guide],
          title: guide.splash_title,
          HTMLTitle: guide.html_title,
          message: guide.message,
        };
      }
      return {
        guides: R.filter((g) => g.active && !g.hidden && g.type !== "EntryPoint", guides),
      };
    },
  });

  const guidesProps = {
    tenantName,
    message: propsFromGuides.message || home_page_message,
    title: propsFromGuides.title || home_page_title,
    stateAbbreviation,
    bounds,
    guides: propsFromGuides.guides || [],
    address,
    phone,
    zipcode,
    websiteURL,
    municipalityType,
    disclaimer,
  };

  return (
    <div>
      <Helmet>
        <title>{propsFromGuides.HTMLTitle || site_title}</title>
      </Helmet>
      <main role="main">
        <Guides {...guidesProps} />
      </main>
      <div className={styles.footers}>
        <div className={styles.footer}>
          <Footer />
        </div>
        <div className={styles.line} />
        <Disclaimers />
      </div>
    </div>
  );
};

Home.propTypes = {
  HTMLTitle: PropTypes.string,
};

export default Home;
